import React, { Component } from "react";
import * as Http from "../../http";
import { ErrorCode } from "../../const";

import * as Business from "../../utils/business";
import Loading from "../../components/Loading";
import { MasterTableType } from "../../const";

export default class MasterTableChild extends Component {
  constructor(props) {
    super(props);
    this.type = props.type;
    this.state = {
      loading: true,
      data: [],
      dataOld: [],
      showDeleteAlert: false,
    };
    this.usernameWillDelete = null;
  }

  componentDidMount() {
    this.getListMasterTables();
  }

  getTitleScreen() {
    switch (this.type) {
      case MasterTableType.party_type:
        return "Party Type";
      case MasterTableType.business_sector:
        return "Business Sector";
      default:
        return "";
    }
  }

  getListMasterTables = () => {
    this.setState({
      loading: false,
    });
    Http.getMasterTableByType(this.type).then((res) => {
      const data = [];
      if (res && res.Data) {
        var lstData = Array.isArray(res.Data)
          ? res.Data.sort((a, b) =>
              a.time_changed.localeCompare(b.time_changed),
            )
          : [];
        var lastIndex = lstData.length - 1;
        for (let index = 0; index < lstData.length; index++) {
          const element = res.Data[index];
          var obj = element;
          obj.index = index;
          if (index != lastIndex) {
            obj.isLastItem = false;
          } else {
            obj.isLastItem = true;
          }
          data.push(obj);
        }
      }
      this.setState({
        loading: false,
        data: data,
        dataOld: data,
      });
    });
  };

  onValidate = (lstData) => {
    const dicCheckNameExist = {};
    // Check ban ghi ton tai
    for (let i = 0; i < lstData.length; i++) {
      const obj = lstData[i];
      if (dicCheckNameExist.hasOwnProperty(obj.name)) {
        return `${obj.name} record already exists`;
      }
      if (!obj.name) {
        return `'Name' must not be null`;
      }
      dicCheckNameExist[obj.name] = obj.name;
    }
    return null;
  };

  onUpdateData = () => {
    const errorMsg = this.onValidate(this.state.data);
    if (errorMsg) {
      Business.showAlert({
        title: "Error",
        content: errorMsg,
      });
      return;
    }

    this.setState(
      {
        loading: true,
      },
      () => {
        const listData = [];
        for (let i = 0; i < this.state.data.length; i++) {
          const obj = this.state.data[i];
          const newObj = { name: obj.name, value: obj.value, type: this.type };
          listData.push(newObj);
        }
        Http.updateMasterTable(listData, this.type).then((res) => {
          this.handleErrorCode(res);
          this.getListMasterTables();
        });
      },
    );
  };

  onCancel = () => {
    this.setState({
      data: this.state.dataOld,
    });
  };

  onAddItem = (index) => {
    const data = JSON.parse(JSON.stringify(this.state.data));

    data.splice(index + 1, 0, {
      name: "",
      value: 0,
      type: this.type,
    });
    const lstData = [];
    const lastIndex = data.length - 1;
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      var obj = element;
      obj.index = index;
      if (index != lastIndex) {
        obj.isLastItem = false;
      } else {
        obj.isLastItem = true;
      }
      lstData.push(obj);
    }
    this.setState({ data: lstData });
  };

  onRemoveItem = (index) => {
    const data = JSON.parse(JSON.stringify(this.state.data));
    if (index > -1) {
      data.splice(index, 1);
    }
    const lstData = [];
    const lastIndex = data.length - 1;
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      var obj = element;
      obj.index = index;
      if (index != lastIndex) {
        obj.isLastItem = false;
      } else {
        obj.isLastItem = true;
      }
      lstData.push(obj);
    }
    this.setState({ data: lstData });
  };

  handleErrorCode(res) {
    if (res) {
      if (res.ErrorCode) {
        switch (res.ErrorCode) {
          case ErrorCode.PermissionDenie:
            Business.showAlert({
              title: "Error",
              content: "You do not have permission",
            });
            break;
          default:
            Business.showAlert({
              title: "Error",
              content: res.Data || "Unknow Error",
            });
            break;
        }
      } else {
        Business.showAlert({ title: "Info", content: "Successfully" });
      }
    } else {
      Business.showAlert({ title: "Error", content: "Unknow Error" });
    }
  }

  renderRow = (index) => {
    const item = this.state.data[index];
    const nameVal = item ? item.name : "";
    const valueVal = item ? item.value : 0;
    return (
      <div key={index} className="ey-master-row">
        <div className="ey-master-row-name">
          <label className="ey-master-label">Name</label>
          <input
            type="text"
            className="ey-master-input"
            value={nameVal}
            onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const obj = data[index] || {};
              obj.name = event.target.value;
              data[index] = obj;
              this.setState({ data });
            }}
          />
        </div>
        <div className="ey-master-row-value">
          <label className="ey-master-label">Value</label>
          <input
            type="number"
            min="0"
            max="100"
            className="ey-master-input"
            value={valueVal}
            onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const obj = data[index] || {};
              obj.value = event.target.value;
              data[index] = obj;
              this.setState({ data });
            }}
          />
        </div>
        <div className="ey-master-row-actions">
          <button
            type="button"
            className="ey-master-action-btn ey-master-action-remove"
            title="Remove row"
            onClick={() => this.onRemoveItem(index)}
          >
            <i className="pe-7s-less" />
          </button>
          <button
            type="button"
            className="ey-master-action-btn ey-master-action-add"
            title="Add row below"
            onClick={() => this.onAddItem(index)}
          >
            <i className="pe-7s-plus" />
          </button>
        </div>
      </div>
    );
  };

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    const listRender = [];
    this.state.data.forEach((e) => {
      listRender.push(this.renderRow(e.index));
    });
    return (
      <div className="card">
        <div className="header">
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h4 className="title">{this.getTitleScreen()}</h4>
            <div style={{ display: "flex", gap: 8 }}>
              <button
                type="button"
                className="ey-master-btn ey-master-btn-save"
                onClick={() => this.onUpdateData()}
              >
                <i className="pe-7s-check" /> Update
              </button>
              <button
                type="button"
                className="ey-master-btn ey-master-btn-cancel"
                onClick={() => this.onCancel()}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        <div className="content" style={{ padding: "20px 24px" }}>
          <div className="ey-master-list-header">
            <span className="ey-master-col-name">Name</span>
            <span className="ey-master-col-value">Value</span>
            <span className="ey-master-col-actions">Actions</span>
          </div>
          <div className="ey-master-list">{listRender}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/MasterTable/MasterTableChild.js